__turbopack_context__.v({
  "Footer": "zsOl_a_Footer",
  "WidgetFooterText": "zsOl_a_WidgetFooterText",
  "WidgetHeader": "zsOl_a_WidgetHeader",
  "WidgetHeaderTitle": "zsOl_a_WidgetHeaderTitle",
  "WidgetModal": "zsOl_a_WidgetModal",
  "WidgetModalContainer": "zsOl_a_WidgetModalContainer",
  "WidgetModalHeader": "zsOl_a_WidgetModalHeader",
  "WidgetQuestion": "zsOl_a_WidgetQuestion",
  "WidgetQuestions": "zsOl_a_WidgetQuestions",
  "WidgetSmall": "zsOl_a_WidgetSmall",
  "WidgetWrapper": "zsOl_a_WidgetWrapper",
});
